const EMAIL_SETTINGS_INITIAL_VALUES = {
  timing: "twicedaily",
  types: "relevant",
  distance: "10",
  popularJobAlert: true,
};

export default EMAIL_SETTINGS_INITIAL_VALUES;
